import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPRODUCTSSAMECATEGORYBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "primary_button_background_color",
  "primary_button_text_color",
  { type: 'separator' },
  "text_color",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskProductsSameCategoryBlockDescriptor: _generatedKioskProductsSameCategoryBlockDescriptor,
  kioskProductsSameCategoryBlockBlocDefinition,
  kioskProductsSameCategoryBlockDashboardLayout,
  kioskProductsSameCategoryBlockConfig,
  kioskProductsSameCategoryBlockResolveConfig,
  kioskProductsSameCategoryBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk - Products Same Category",
    componentType: 'KioskProductsSameCategoryBlockComponent',
    category: 'kiosk',
    description: "Kiosk - Products Same Category.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskLightProductDetailsPageComponent', slot: 'body' },
    ],


    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.kiosk-products-same-category.heading.label",
      }
    }),
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.primary-button-background-color.label",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.secondary-button-text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#000"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.text-color.label",
      }
    }),
    card_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.kiosk-products-same-category.card-color.label",
      }
    })
  }),

  () => ({
    omitFields: [
      "secondary_button_background_color",
      "secondary_button_text_color",
      "background_color",
      "card_color",
    ] as const,
    tabs: [
      {
        label: "pages.blocks.kiosk-products-same-category.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-products-same-category.fieldset.title.label",
            fields: ["heading", "text_color"],
          },
          {
            legend: "pages.blocks.kiosk-products-same-category.fieldset.card-button.label",
            fields: ["primary_button_background_color", "primary_button_text_color"],
          },
        ],
      },
    ],
  })
);

export function kioskProductsSameCategoryBlockDescriptor(): IBlockDescriptor;
export function kioskProductsSameCategoryBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskProductsSameCategoryBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskProductsSameCategoryBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskProductsSameCategoryBlockDescriptor, kioskProductsSameCategoryBlockProperties, fieldOrder);
}

export {
  kioskProductsSameCategoryBlockBlocDefinition,
  kioskProductsSameCategoryBlockDashboardLayout,
  kioskProductsSameCategoryBlockProperties,
  kioskProductsSameCategoryBlockConfig,
  kioskProductsSameCategoryBlockResolveConfig,
};

export type KioskProductsSameCategoryBlockConfig = typeof kioskProductsSameCategoryBlockConfig;
